import { Divider } from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";
import type { FC, PropsWithChildren } from "react";

interface InfoBannerProps {
    variant?: "info" | "warning";
    windowWidth: number;
    showDivider?: boolean;
    ariaLabel?: string;
}

const InfoBanner: FC<PropsWithChildren<InfoBannerProps>> = ({
    variant = "info",
    children,
    windowWidth,
    showDivider = true,
    ariaLabel,
}) => {
    const getIcon = () => {
        const iconProps = {
            "aria-hidden": "true" as const,
            role: "presentation" as const,
        };
        
        switch (variant) {
            case "warning":
                return <InfoIcon style={{ color: "var(--orange)" }} {...iconProps} />;
            case "info":
            default:
                return <InfoIcon color="primary" {...iconProps} />;
        }
    };

    const getBannerStyles = () => {
        const baseStyles = {
            width: "100%",
            display: "flex",
            flexDirection: "row" as const,
            flexWrap: "nowrap" as const,
            alignItems: "center",
            justifyContent: "center",
            gap: windowWidth < 800 ? "16px" : "8px",
            padding: "0px 16px",
        };

        if (variant === "warning") {
            return {
                ...baseStyles,
                backgroundColor: "#fff3e0",
                margin: "8px 0",
                padding: "12px 16px",
                color: "#686868",
            };
        }

        return baseStyles;
    };

    const defaultAriaLabel = variant === "warning" ? "Warning" : "Information";
    
    return (
        <>
            <div 
                className="about" 
                style={getBannerStyles()}
                role="alert"
                aria-label={ariaLabel || defaultAriaLabel}
            >
                {getIcon()}
                <div>{children}</div>
            </div>
            {showDivider && windowWidth < 800 && <Divider />}
        </>
    );
};

export default InfoBanner;
